import { PasswordState } from '@/store/types';
import { MutationTree } from 'vuex';

const mutations: MutationTree<PasswordState> = {
  setPassword(state: PasswordState, password): void {
    state.password = password;
  },
  setNewPassword(state: PasswordState, password): void {
    state.newPassword = password;
  },
  setConfirmNewPassword(state: PasswordState, password): void {
    state.confirmNewPassword = password;
  },
  clear(state: PasswordState) {
    state.password = '';
    state.newPassword = '';
    state.confirmNewPassword = '';
  },
  setPutError(state: PasswordState, message: string): void {
    state.requestError.put.message = message;
  },
  setPutSuccess(state: PasswordState, message: string): void {
    state.requestSuccess.message = message;
  },
  clearPutError(state: PasswordState): void {
    state.requestError.put.message = '';
  },
  clearPutSuccess(state: PasswordState): void {
    state.requestSuccess.message = '';
  },
};

export default mutations;
